<template>
    <div class="browserMask" @click="close">
        <img v-if="imgUrl" class="type" :src="imgUrl"/>
        <i></i>
        <img class="header" :src="header" alt="">
        <img class="footer" :src="footer" alt="">
    </div>
</template>

<script>

export default {
name: "browserMask",
data() {
    return {

    };
},
props:{
    imgUrl: {
        default: '',
    },
    header:{
        default: "https://appd.knowbox.cn/ss/boxParentService/homework/download/header.png"
    },
    footer:{
        default: "https://appd.knowbox.cn/ss/boxParentService/homework/download/footer.png"
    }
},
components:{

},

created() {

},
mounted (){

},
methods: {
    close(){
        this.$emit('close');
    }
},
};
</script>
<style lang="scss" scoped >
.browserMask{
    width: 100%;
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    background: #fff;
    position: fixed;
    left: 0;
    top: 0;
    .type {
        width: 4.40rem;
        height: 3.08rem;
        position: absolute;
        top:1.20rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
    }
    i{
        display: block;
        width: 100%;
        height: 100%;
        background: rgba($color: #000000, $alpha: 0.7);
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
    }
    .footer {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: auto;
        z-index: 3;
    }
    .header {
        position: absolute;
        top: .30rem;
        right: .50rem;
        width: 5.21rem;
        height: 3.52rem;
        z-index: 3;
    }
}   
</style>